// tslint:disable
import { transfromToPhotoViews } from "../../libs/GooglePicker"
import { PhotoView } from "../../models/PhotoModel"
import { GooglePickerResult } from "../../libs/GooglePickerResult"
import __6mai = require("./6mai.json")
import __4x3_6 = require("./4x3-6.json")
import __3x2_4 = require("./3x2-4.json")
import __3x2_3 = require("./3x2-3.json")
import __4x3_3 = require("./4x3-3.json")
import __4x3_2 = require("./4x3-2.json")
import __4x3_9 = require("./4x3-9.json")
import __4x3_4 = require("./4x3-4.json")
import __4x3_33 = require("./4x3-33.json")
import __3x4_4x3_3 = require("./3x4-4x3-3.json")
import __16x9_3x2_2 = require("./16x9-3x2-2.json")
import __9x16_3x2_2 = require("./9x16-3x2-2.json")
import __4x3_3x4_4x3_2 = require("./4x3-3x4-4x3-2.json")
import __2x3_16x9_3x2_2 = require("./2x3-16x9-3x2-2.json")
const _6mai = __6mai as GooglePickerResult
const _4x3_6 = __4x3_6 as GooglePickerResult
const _3x2_4 = __3x2_4 as GooglePickerResult
const _3x2_3 = __3x2_3 as GooglePickerResult
const _4x3_3 = __4x3_3 as GooglePickerResult
const _4x3_2 = __4x3_2 as GooglePickerResult
const _4x3_9 = __4x3_9 as GooglePickerResult
const _4x3_4 = __4x3_4 as GooglePickerResult
const _4x3_33 = __4x3_33 as GooglePickerResult
const _3x4_4x3_3 = __3x4_4x3_3 as GooglePickerResult
const _16x9_3x2_2 = __16x9_3x2_2 as GooglePickerResult
const _9x16_3x2_2 = __9x16_3x2_2 as GooglePickerResult
const _4x3_3x4_4x3_2 = __4x3_3x4_4x3_2 as GooglePickerResult
const _2x3_16x9_3x2_2 = __2x3_16x9_3x2_2 as GooglePickerResult

// type PickerMockName = '_6mai' | '_4x3_6' | '_3x2_4' | '_3x2_3' | '_4x3_3' | '_4x3_2' | '_4x3_9' | '_4x3_4' | '_4x3_33' | '_3x4_4x3_3' | '_16x9_3x2_2' | '_9x16_3x2_2' | '_4x3_3x4_4x3_2' | '_2x3_16x9_3x2_2'

export const GooglePickedMockData = {
  _6mai,
  _4x3_6,
  _3x2_4,
  _3x2_3,
  _4x3_3,
  _4x3_2,
  _4x3_9,
  _4x3_4,
  _4x3_33,
  _3x4_4x3_3,
  _16x9_3x2_2,
  _9x16_3x2_2,
  _4x3_3x4_4x3_2,
  _2x3_16x9_3x2_2
}
export type PickerMockName = keyof typeof GooglePickedMockData

export async function loadByMock(name: PickerMockName): Promise<PhotoView[]> {
  return syncLoadByMock(name)
}

export function syncLoadByMock(name: PickerMockName) {
  const data = GooglePickedMockData[name]
  return transfromToPhotoViews(data)
}

/* -- tests --

expect(await loadByMock('_6mai')).toHaveLength(3);
expect(await loadByMock('_4x3_6')).toHaveLength(3);
expect(await loadByMock('_3x2_4')).toHaveLength(3);
expect(await loadByMock('_3x2_3')).toHaveLength(3);
expect(await loadByMock('_4x3_3')).toHaveLength(3);
expect(await loadByMock('_4x3_2')).toHaveLength(3);
expect(await loadByMock('_4x3_9')).toHaveLength(3);
expect(await loadByMock('_4x3_4')).toHaveLength(3);
expect(await loadByMock('_4x3_33')).toHaveLength(3);
expect(await loadByMock('_3x4_4x3_3')).toHaveLength(3);
expect(await loadByMock('_16x9_3x2_2')).toHaveLength(3);
expect(await loadByMock('_9x16_3x2_2')).toHaveLength(3);
expect(await loadByMock('_4x3_3x4_4x3_2')).toHaveLength(3);
expect(await loadByMock('_2x3_16x9_3x2_2')).toHaveLength(3);
*/
